import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { AddIcon } from 'Shared/Icons';
import { FlowTransformationBlock } from 'Shared/flows/flows-interface/FlowTransformationBlock';
import http from 'Utils/http';
import { useDispatch } from "react-redux";
import { cacheFlowMethod } from 'Actions/flowMethodResponse';

export const FlowTransformationList = ({ transformations, addNewChain, setVisibleFormTransformation, isHiddenField, presetOperation, defaultTitle, updateItems }) => {
    useEffect(() => {
        if (transformations && !transformations?.length) {
            setVisibleFormTransformation(false);
        }
    }, [transformations, setVisibleFormTransformation]);

    const dispatch = useDispatch();
    const flowMethodIdsRef = useRef(new Set());
    const timeoutRef = useRef(null);
    const [registeredCount, setRegisteredCount] = useState(0);
    const [allFlowMethods, setAllFlowMethods] = useState(false);

    const registerFlowMethodId = useCallback((id) => {
        if (id && !flowMethodIdsRef.current.has(id)) {
            flowMethodIdsRef.current.add(id);
            setRegisteredCount(prev => prev + 1);

            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                handleFetchData();
            }, 50);
        }
    }, []);

    const handleFetchData = useCallback(() => {
        const ids = Array.from(flowMethodIdsRef.current);
        if (ids.length > 0) {
            const params = {
                flow_method_ids: ids
            };
            http.post(`/flow/method/batch/get`, params).then((res) => {
                res.data.flowMethods.forEach((method) => {
                    dispatch(cacheFlowMethod(method.id, method));
                });
                setAllFlowMethods(true);
            }).catch((err) => {
            }).finally(() => {
            });
        }
    }, []);
    useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
    }, []);

    const addNewChainV2 = () => {
        const lastTransformation = transformations[transformations?.length - 1];
        let params = {
            flow_method_id: lastTransformation.flow_method_id,
            previous_id: lastTransformation.id,
        };
        addNewChain(params);
    };

    return (
        <>
            {transformations && transformations.length > 0 && transformations.map((item, index) => (
                <FlowTransformationBlock
                    preset_operation={presetOperation}
                    is_hidden_field={isHiddenField}
                    updateItems={updateItems}
                    key={`${index}_${item.id}`}
                    index={index}
                    is_last_index={transformations.length === (index + 1)}
                    transformation_id={item.id}
                    source_id={item.source_id}
                    source_flow_method_id={item.source_flow_method_id}
                    previous_id={item.previous_id}
                    flow_method_id={item.flow_method_id}
                    default_title={defaultTitle}
                    onRegisterFlowMethodId={registerFlowMethodId}
                    allFlowMethods={allFlowMethods}
                />
            ))}

            {transformations && transformations?.length > 0 && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                        marginTop: '17px',
                        marginLeft: 'auto',
                        marginRight: '12px',
                        cursor: 'pointer',
                        '& .MuiTypography-body1': {
                            transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
                        },
                        '& .add-icon path': {
                            transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
                        },
                        '&:hover': {
                            '.MuiTypography-body1': {
                                color: '#197AC0',
                            },
                            '.add-icon path': {
                                fill: '#197AC0',
                            },
                        },
                    }}
                    onClick={addNewChainV2}
                >
                    <AddIcon />
                    <Typography color="primary">Add New Chain</Typography>
                </Box>
            )}
        </>
    );
};
